<div class="d-flex flex-row gap-4">
    <div class="summary-appointment-container d-flex flex-column">
        <h2>{{'asset.serviceAppointment.summary' | translate}}</h2>

        <kendo-stepper
            [steps]="summarySteps"
            stepType="full"
            [(currentStep)]="currentStep"
            (currentStepChange)="currentStepChangeHandler($event)"
            [linear]="true"
            [style.width.px]="350"
            orientation="vertical"
        >

            <ng-template kendoStepperLabelTemplate let-step>
                <div class="step-label d-flex flex-column">
                    <div class="fw-bold">{{ 'asset.serviceAppointment.' + step.label | translate }}</div>

                    <div class="additional-info d-flex flex-column">
                        @switch (step.code) { 
                        @case ('BOOK') {
                            <div class="d-flex flex-column text-secondary">
                                <span class="">{{ _dataService.saveModel.registrationNumber }}</span>
                                <span class="">{{ _dataService.saveModel.serviceName }}</span>
                            </div>
                        } @case ('TIMESLOT') {
                            <div class="d-flex flex-column text-secondary">
                                <span class="">{{ _dataService.saveModel.serviceLocationName }}</span>
                                <span class="">{{ _dataService.saveModel.timeslotDate }}</span>
                            </div>
                        }}
                    </div>
                </div>
            </ng-template>
        </kendo-stepper>
    </div>
    
    <div class="main-appointment-container flex-grow-1">
        <div class="d-flex flex-column gap-3 me-3">
            <h2>{{'asset.serviceAppointment.title' | translate}}</h2>
            
            <div class="d-flex gap-4">
                <div class="rounded-top-lg flex-grow-1 d-flex gap-2 align-items-center service-partner-search-box">
                    <i class="app-icon icon icon-search icon-xl text-secondary"></i>
        
                    <kendo-autocomplete HJSuppress
                        class="custom-kendo-control-xl custom-text-input-container search-container flex-grow-1"
                        [rounded]="'large'"
                        [placeholder]="'asset.serviceAppointment.searchPartnerPlaceholder' | translate"
                        [clearButton]="false"
                        [data]="autocompleteDatasource"
                        [filterable]="true"
                        [valueField]="'value'"
                        [(ngModel)]="autocompleteValue.value"
                        (ngModelChange)="servicePartnerSelectedHandler($event)"
                        (filterChange)="filterDataSource($event)"
                    >
                    </kendo-autocomplete>
                </div>
        
                <button class="btn" 
                    [ngClass]="selectedFilteringMode === 'NEAREST' ? 'btn-outline-primary' : 'btn-outline-dark'"
                    (click)="selectedFilteringMode = 'NEAREST'"
                >
                    {{'asset.serviceAppointment.nearest' | translate | uppercase}}
                </button>
        
                <button class="btn" 
                    [ngClass]="selectedFilteringMode === 'EARLIEST' ? 'btn-outline-primary' : 'btn-outline-dark'"
                    (click)="selectedFilteringMode = 'EARLIEST'"
                >
                    {{'asset.serviceAppointment.earliest' | translate | uppercase}}
                </button>
            </div>
        </div>
        
        <days-list *ngIf="dataLoaded"
            [(value)]="_dataService.saveModel.scheduleDate"
            [availableDays]="dataAvailableDays"
            (valueChange)="onDayChange($event)"
            [availabilityLabelText]="'asset.serviceAppointment.availableDays' | translate"
            [calendarLabelToday]="'calendar.today' | translate"
        >
        </days-list>
        
        <div class="d-flex flex-column p-4 mt-3 gap-2">
            <div *ngIf="dayHasTimeSlots; else noAppointmentsAvailable" 
                class="d-flex flex-column gap-3 gap-5"
            >
                <div *ngFor="let scheduleModel of scheduleModels | filterArray:filterDisplayedTimeSlotGroupsCallback; let isLast = last" class="d-flex flex-column gap-4">
                    <div class="d-flex justify-content-between fw-bold">
                        <span class="">{{scheduleModel.name}}</span>
                        <span class="text-secondary">{{scheduleModel.distance | number:'1.0-2'}} {{scheduleModel.distanceMu}} {{'asset.serviceAppointment.distance' | translate}}</span>
                    </div>
            
                    <div class="d-flex gap-4 flex-wrap">
                        <div *ngFor="let slotInterval of scheduleModel.timeSlots" class="d-flex">
                            <span 
                                class="slot-card d-flex justify-content-center align-items-center fw-bold timeSlotCard" 
                                [ngClass]="{'is-slot-selected' : slotInterval.timeSlotId === _dataService.saveModel.timeSlotId}"
                                (click)="onTimeSlotDetailChange(_dataService.saveModel.timeSlotId = slotInterval.timeSlotId)"
                            >
                                {{slotInterval.startTime | date:"shortTime"}} - {{slotInterval.endTime | date:"shortTime"}}
                            </span>
                        </div>
                    </div>
            
                    <div *ngIf="!isLast" class="hr"></div>
                </div>
            </div>
            
            <div class="card p-4 bottom-navigation d-flex flex-row gap-3 align-self-end w-100">
                <button class="btn btn-outline-dark gap-2" (click)="currentStepChangeHandler(0)">
                    <i class="app-icon icon icon-arrow-left icon-md"></i>
                    {{'common.previousButton' | translate | uppercase}}
                </button>
                <button class="btn btn-primary text-light" [disabled]="!_dataService.saveModel.timeSlotId" (click)="confirmBtnClickHandler()">
                    {{'common.confirmButton' | translate | uppercase}}
                </button>
            </div>
        </div>
        
        <ng-template #noAppointmentsAvailable>
            <div class="no-appointments-available card flex-grow-1 rounded-top-lg">
                <div class="card-body d-flex flex-column align-items-center justify-content-center">
                    <img class="mb-3" src="assets/img/global-SVG-assets/SVG4-custom-themes/no-records.svg" alt="">
                    <p>{{ 'asset.serviceAppointment.noTimeSlotsAvailable' | translate }}</p>
                </div>
            </div>
        </ng-template>
    </div>
</div>

